module.exports = __webpack_public_path__ + "static/media/AccountPaymentScreen.f6752722.png";